import { motion } from "framer-motion";
import { MessageCircle, Instagram } from "lucide-react";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: [0.33, 1, 0.68, 1] },
};

export const Footer = () => {
  return (
    <footer
      data-testid="footer-section"
      className="relative px-6 md:px-16 lg:px-24 py-8 md:py-12"
    >
      <div className="section-divider mb-8 md:mb-10" />

      <motion.div
        {...fadeUp}
        className="flex flex-col md:flex-row md:items-end justify-between gap-12"
      >
        {/* Left - branding */}
        <div>
          <h2 className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-tight text-ink">
            INSTINCT
          </h2>
          <p className="mt-4 text-sm tracking-[0.15em] uppercase text-sig/60 font-['IBM_Plex_Sans'] font-light">
            Train the weapon you already are.
          </p>
          <a
            href="tel:+919958915302"
            className="mt-4 block text-lg font-['Oswald'] font-bold text-ink hover:text-sig transition-colors tracking-wide"
          >
            +91 99589 15302
          </a>
        </div>

        {/* Right - links */}
        <div className="flex flex-col items-start md:items-end gap-4">
          <div className="flex gap-3">
            <a
              data-testid="footer-instagram-link"
              href="https://www.instagram.com/instinct.kravmaga"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-sig hover:text-ink transition-colors font-['IBM_Plex_Sans'] group border border-sig/30 px-6 py-3 hover:bg-sig/10"
            >
              <Instagram className="w-4 h-4" />
              Instagram
            </a>
            <a
              data-testid="whatsapp-link"
              href="https://wa.me/919958915302"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-sig hover:text-ink transition-colors font-['IBM_Plex_Sans'] group border border-sig/30 px-6 py-3 hover:bg-sig/10"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
          <p className="text-[11px] tracking-[0.15em] text-line font-['IBM_Plex_Sans']">
            &copy; INSTINCT 2025
          </p>
        </div>
      </motion.div>
    </footer>
  );
};
